import React from 'react';

const AchievementBadge = ({ achievement, onClick }) => {
  const getBadgeStyle = (unlocked) => {
    if (unlocked) {
      return 'border-green-500 bg-green-50 dark:bg-green-900/20 hover:bg-green-100 dark:hover:bg-green-900/30 cursor-pointer transform hover:scale-105 transition-all duration-200';
    }
    return 'border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 opacity-50 cursor-not-allowed';
  };

  const getIconStyle = (unlocked) => {
    return unlocked ? 'text-3xl mb-2' : 'text-3xl mb-2 grayscale';
  };

  const getTextStyle = (unlocked) => {
    if (unlocked) {
      return {
        title: 'text-gray-800 dark:text-white',
        description: 'text-gray-600 dark:text-gray-300'
      };
    }
    return {
      title: 'text-gray-500 dark:text-gray-400',
      description: 'text-gray-400 dark:text-gray-500'
    };
  };

  const textStyles = getTextStyle(achievement.unlocked);

  return (
    <div
      className={`p-4 rounded-2xl border-2 ${getBadgeStyle(achievement.unlocked)}`}
      onClick={() => achievement.unlocked && onClick && onClick(achievement)}
    >
      <div className="text-center">
        <div className={getIconStyle(achievement.unlocked)}>
          {achievement.icon}
        </div>
        <h4 className={`font-semibold text-sm ${textStyles.title}`}>
          {achievement.name}
        </h4>
        <p className={`text-xs mt-1 ${textStyles.description}`}>
          {achievement.description}
        </p>
        {achievement.unlocked && (
          <div className="mt-2">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
              ✓ Unlocked
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AchievementBadge; 